import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';
import { ReactComponent as Logout } from '../../../assets/logout.svg';
import useStyles from './LogoutIcon.styles';

const LogoutIcon = () => {
  const classes = useStyles();

  return <SvgIcon classes={classes} component={Logout} title="Log Out" fontSize="large" viewBox="0 0 24 24" />;
};

export default React.memo(LogoutIcon);
